var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImgpreview3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 285,
  height: 140,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#img_preview3_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#img_preview3_svg__b)",
  opacity: 0.1
}, /*#__PURE__*/React.createElement("rect", {
  width: 213,
  height: 104,
  x: 35,
  y: 17,
  fill: "#008060",
  rx: 52
})), /*#__PURE__*/React.createElement("rect", {
  width: 142.6,
  height: 119.167,
  x: 71,
  y: 10,
  fill: "#fff",
  stroke: "#ECECEC",
  strokeWidth: 2,
  rx: 4.833
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF7E92",
  d: "M79.875 21.75a2.875 2.875 0 1 0 0-5.75 2.875 2.875 0 0 0 0 5.75"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFD05B",
  d: "M89.459 21.75a2.875 2.875 0 1 0 0-5.75 2.875 2.875 0 0 0 0 5.75"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#98DB7C",
  d: "M99.042 21.75a2.876 2.876 0 1 0 0-5.751 2.876 2.876 0 0 0 0 5.751"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ECECEC",
  d: "M197.709 16h-88.001a3 3 0 0 0 0 6h88.001a3 3 0 0 0 0-6"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M209.5 16h-1a3 3 0 1 0 0 6h1a3 3 0 1 0 0-6"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D2D5D8",
  d: "M199.083 28H81.917A1.917 1.917 0 0 0 80 29.917v17.166c0 1.059.858 1.917 1.917 1.917h117.166A1.917 1.917 0 0 0 201 47.083V29.917A1.917 1.917 0 0 0 199.083 28"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E8E9EB",
  d: "M101.885 52.844h-19.6a1.917 1.917 0 0 0-1.916 1.916v63.119c0 1.059.858 1.917 1.916 1.917h19.6a1.917 1.917 0 0 0 1.917-1.917V54.76a1.917 1.917 0 0 0-1.917-1.916M199.083 53h-90.166A1.917 1.917 0 0 0 107 54.917v2.166c0 1.059.858 1.917 1.917 1.917h90.166A1.917 1.917 0 0 0 201 57.083v-2.166A1.917 1.917 0 0 0 199.083 53M127.233 62.05h-18.166a1.917 1.917 0 0 0-1.917 1.917v18.167c0 1.059.858 1.917 1.917 1.917h18.166a1.917 1.917 0 0 0 1.917-1.917V63.967a1.917 1.917 0 0 0-1.917-1.916M151.233 62.05h-18.166a1.917 1.917 0 0 0-1.917 1.917v18.167c0 1.059.858 1.917 1.917 1.917h18.166a1.917 1.917 0 0 0 1.917-1.917V63.967a1.917 1.917 0 0 0-1.917-1.916M175.233 62.05h-18.166a1.917 1.917 0 0 0-1.917 1.917v18.167c0 1.059.858 1.917 1.917 1.917h18.166a1.917 1.917 0 0 0 1.917-1.917V63.967a1.917 1.917 0 0 0-1.917-1.916M199.233 62.05h-18.166a1.917 1.917 0 0 0-1.917 1.917v18.167c0 1.059.858 1.917 1.917 1.917h18.166a1.917 1.917 0 0 0 1.917-1.917V63.967a1.917 1.917 0 0 0-1.917-1.916M127.233 87.158h-18.166a1.917 1.917 0 0 0-1.917 1.917v18.167c0 1.058.858 1.916 1.917 1.916h18.166a1.916 1.916 0 0 0 1.917-1.916V89.075a1.917 1.917 0 0 0-1.917-1.917M151.233 87.158h-18.166a1.917 1.917 0 0 0-1.917 1.917v18.167c0 1.058.858 1.916 1.917 1.916h18.166a1.916 1.916 0 0 0 1.917-1.916V89.075a1.917 1.917 0 0 0-1.917-1.917M175.233 87.158h-18.166a1.917 1.917 0 0 0-1.917 1.917v18.167c0 1.058.858 1.916 1.917 1.916h18.166a1.916 1.916 0 0 0 1.917-1.916V89.075a1.917 1.917 0 0 0-1.917-1.917M199.233 87.158h-18.166a1.917 1.917 0 0 0-1.917 1.917v18.167c0 1.058.858 1.916 1.917 1.916h18.166a1.916 1.916 0 0 0 1.917-1.916V89.075a1.917 1.917 0 0 0-1.917-1.917"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D2D5D8",
  d: "M162.143 113.939h-13.741a1.917 1.917 0 0 0-1.917 1.917v2.025c0 1.059.858 1.917 1.917 1.917h13.741a1.917 1.917 0 0 0 1.917-1.917v-2.025a1.917 1.917 0 0 0-1.917-1.917M141.22 113.939h-2.025a1.917 1.917 0 0 0-1.916 1.917v2.025c0 1.059.858 1.917 1.916 1.917h2.025a1.917 1.917 0 0 0 1.917-1.917v-2.025a1.917 1.917 0 0 0-1.917-1.917M171.349 113.939h-2.025a1.917 1.917 0 0 0-1.917 1.917v2.025c0 1.059.858 1.917 1.917 1.917h2.025a1.917 1.917 0 0 0 1.917-1.917v-2.025a1.92 1.92 0 0 0-1.917-1.917"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#img_preview3_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M153.797 50.316h-21.595c-5.547 0-10.044 4.498-10.044 10.045v21.595c0 5.547 4.497 10.045 10.044 10.045h21.595c5.548 0 10.045-4.498 10.045-10.045V60.36c0-5.547-4.497-10.045-10.045-10.045"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00A47C",
  d: "M153.797 48h-21.595c-5.547 0-10.044 4.497-10.044 10.045v21.594c0 5.548 4.497 10.045 10.044 10.045h21.595c5.548 0 10.045-4.497 10.045-10.044V58.045c0-5.548-4.497-10.045-10.045-10.045"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M156.553 60.997a2.6 2.6 0 0 1 .566 2.837 2.6 2.6 0 0 1-.566.845l-13.049 13.055-1.847 1.847a2.6 2.6 0 0 1-1.841.764 2.6 2.6 0 0 1-1.841-.764l-7.37-7.376a2.59 2.59 0 0 1-.765-1.84 2.6 2.6 0 0 1 1.609-2.408 2.6 2.6 0 0 1 2.838.566l5.06 5.06a.65.65 0 0 0 .469.196.66.66 0 0 0 .469-.196l12.586-12.586a2.59 2.59 0 0 1 2.838-.566c.316.131.603.324.844.566"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M156.553 58.68a2.6 2.6 0 0 1 .566 2.838 2.6 2.6 0 0 1-.566.844l-13.049 13.056-1.847 1.846a2.6 2.6 0 0 1-1.841.765 2.6 2.6 0 0 1-1.841-.764l-7.37-7.376a2.59 2.59 0 0 1-.765-1.841 2.6 2.6 0 0 1 1.609-2.407 2.6 2.6 0 0 1 2.838.566l5.06 5.06a.65.65 0 0 0 .469.195.66.66 0 0 0 .469-.195l12.586-12.587a2.6 2.6 0 0 1 1.841-.764 2.6 2.6 0 0 1 1.841.764"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#BABEC3",
  d: "M230 38.025a3.023 3.023 0 0 0 3.025 3.024 3.023 3.023 0 0 0 3.024-3.024A3.023 3.023 0 0 0 233.025 35 3.023 3.023 0 0 0 230 38.025M237 110a2 2 0 1 0 3.999.001A2 2 0 0 0 237 110M52 45a1.999 1.999 0 1 0 4 0 1.999 1.999 0 1 0-4 0M46 89.025a3.023 3.023 0 0 0 3.025 3.024 3.023 3.023 0 0 0 3.024-3.025A3.023 3.023 0 0 0 49.025 86 3.023 3.023 0 0 0 46 89.025"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "img_preview3_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h285v140H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "img_preview3_svg__c"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M121 48h44v44h-44z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "img_preview3_svg__b",
  width: 301.945,
  height: 192.945,
  x: -9.472,
  y: -27.472,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_10372_9294",
  stdDeviation: 22.236
})))));
export { SvgImgpreview3 as ReactComponent };
export default __webpack_public_path__ + "static/media/img.preview3.633a1daf.svg";